import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const phraseIntervalDuration = 2250

export default makeStyles((theme: Theme) => ({
    background: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100vh',
        zIndex: theme.zIndexLevels.ten,
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundImage: 'linear-gradient(to bottom, #202633, #0e1117)',
        backgroundSize: 'cover',
    },
    loaded: {
        animation: `$fadeBackground 9s`,
        animationFillMode: 'forwards',
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100vh',

        animation: `$fadeContent 9s`,
        animationFillMode: 'forwards',
    },
    boxWrapper: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    photoWrapper: {
        display: 'flex',
        justifyContent: 'space-around',
        marginTop: 20,
        justifyItems: 'center',

        visibility: 'hidden',
        animation: `$fadeContainer 7s`,
        animationDelay: '1s',
        animationFillMode: 'forwards',
        animationTimingFunction: 'cubic-bezier(0.1, 0.1, 0.7, 1.0)',
    },
    photo: {
        width: 80,
        height: 80,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        marginBottom: 32,

        visibility: 'hidden',
        animation: `$transitionToRight .3s`,
        animationFillMode: 'forwards',
        animationTimingFunction: 'cubic-bezier(0.1, 0.1, 0.7, 1.0)',
        animationDelay: '1.2s',
    },
    title: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        color: theme.colors.white,
        fontWeight: 600,
        fontSize: 16,
        letterSpacing: 6,
        lineHeight: 2,
        textTransform: 'uppercase',
        marginBottom: 8,

        textAlign: 'center',
        visibility: 'hidden',
        animation: `$fadeArtistName 3.5s`,
        animationFillMode: 'forwards',
        animationDelay: '2s',

        '@media (min-width: 768px)': {
            fontSize: 20,
            lineHeight: 1.6,
            letterSpacing: 8,
        },
    },
    showTitle: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        color: theme.colors.white,
        fontSize: 12,
        letterSpacing: 6,
        lineHeight: 2,
        textTransform: 'uppercase',
        objectFit: 'contain',
        textAlign: 'center',
        marginBottom: 24,
        width: 310,

        visibility: 'hidden',
        animation: `$fadeShowTitle 3s`,
        animationFillMode: 'forwards',
        animationDelay: '2.5s',

        '@media (min-width: 768px)': {
            fontSize: 14,
            width: 1024,
            letterSpacing: 7,
            lineHeight: 2.29,
            marginBottom: 32,
        },
    },
    presentedBy: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        color: theme.colors.white,
        fontSize: 10,
        letterSpacing: 6,
        lineHeight: 1.67,
        textTransform: 'uppercase',
        textAlign: 'center',

        visibility: 'hidden',
        animation: `$fadePresentedBy 4s`,
        animationDelay: '3s',
        animationFillMode: 'forwards',
        animationTimingFunction: 'cubic-bezier(0.1, 0.3, 0.7, 1.0)',

        '@media (min-width: 768px)': {
            fontSize: 12,
        },
    },
    loaderWrapper: {
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: theme.colors.extraColors.neutral.Neutral100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    loaderIcon: {
        height: '25%',
        width: '25%',
        position: 'relative',
    },
    '@keyframes fadeBackground': {
        '0%': {
            opacity: 1,
        },
        '85%': {
            opacity: 1,
        },
        '90%': {
            opacity: 0.5,
        },
        '99%': {
            opacity: 0,
            transform: 'scale(1)',
        },
        '100%': {
            opacity: 0,
            transform: 'scale(0)',
        },
    },
    '@keyframes fadeContent': {
        '0%': {
            opacity: 1,
            transform: 'scale(1)',
        },
        '98%': {
            opacity: 1,
            transform: 'scale(1)',
        },
        '99%': {
            opacity: 0,
            transform: 'scale(1)',
        },
        '100%': {
            opacity: 0,
            transform: 'scale(0)',
        },
    },
    '@keyframes fadePresentedBy': {
        '0%': {
            visibility: 'visible',
            opacity: 0,
        },
        '9%': {
            opacity: 0,
            transform: 'translate(0, 100%)',
        },
        '13%': {
            opacity: 0.1,
            transform: 'none',
        },
        '15%': {
            opacity: 0.2,
            transform: 'none',
        },
        '20%': {
            opacity: 0.3,
            transform: 'none',
        },
        '25%': {
            opacity: 0.6,
            transform: 'none',
        },
        '85%': {
            opacity: 0.6,
            transform: 'none',
        },
        '90%': {
            opacity: 0.6,
            transform: 'none',
        },
        '100%': {
            opacity: 0,
        },
    },
    '@keyframes fadeContainer': {
        '0%': {
            visibility: 'visible',
            opacity: 0,
        },
        '14%': {
            opacity: 0.5,
        },
        '25%': {
            opacity: 0.8,
        },
        '30%': {
            opacity: 1,
        },
        '85%': {
            opacity: 1,
        },
        '90%': {
            opacity: 0.5,
        },
        '100%': {
            opacity: 0,
        },
    },
    '@keyframes transitionToRight': {
        from: {
            visibility: 'visible',
            opacity: 0,
            transform: 'translate3d(-100%, 0, 0)',
        },
        to: {
            visibility: 'visible',
            opacity: 1,
            transform: 'none',
        },
    },
    '@keyframes fadeArtistName': {
        '0%': {
            visibility: 'visible',
            opacity: 0,
        },
        '11%': {
            opacity: 0,
            transform: 'translate(0, -100%)',
        },
        '14%': {
            opacity: 0.5,
            transform: 'none',
        },
        '17%': {
            opacity: 0.7,
            transform: 'none',
        },
        '24%': {
            opacity: 0.9,
            transform: 'none',
        },
        '30%': {
            opacity: 1,
            transform: 'none',
        },
        '85%': {
            opacity: 1,
            transform: 'none',
        },
        '90%': {
            opacity: 0.5,
            transform: 'none',
        },
        '100%': {
            opacity: 0,
        },
    },
    '@keyframes fadeShowTitle': {
        '0%': {
            visibility: 'visible',
            opacity: 0,
        },
        '13%': {
            opacity: 0,
            transform: 'translate(0, -100%)',
        },
        '17%': {
            opacity: 0.3,
            transform: 'none',
        },
        '19%': {
            opacity: 0.4,
            transform: 'none',
        },
        '20%': {
            opacity: 0.6,
            transform: 'none',
        },
        '25%': {
            opacity: 0.6,
            transform: 'none',
        },
        '85%': {
            opacity: 0.6,
            transform: 'none',
        },
        '90%': {
            opacity: 0.5,
            transform: 'none',
        },
        '100%': {
            opacity: 0,
        },
    },
}))
